// extracted by mini-css-extract-plugin
export default {"root":"pending-approval-badge_root__sBEcw","note":"pending-approval-badge_note__ju4aI","icon":"pending-approval-badge_icon__Lxq46"};